import {NgModule} from '@angular/core';
import {DynamicComponentComponent} from './dynamic-component.component';
import {SharedImportsModule} from '../../modules/shared-imports.module';

@NgModule({
    imports: [
        SharedImportsModule
    ],
    declarations: [
        DynamicComponentComponent
    ],
    exports: [
        DynamicComponentComponent
    ]
})
export class DynamicComponentModule {
}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/shared/components/dynamic-component/dynamic-component.module.ts